import Link from 'next/link'
import { useNumberItemsCart } from '@/providers/NumberItemsCartProvider'
import { ShoppingBagIcon } from '@heroicons/react/24/solid'

export default function CartButton() {
  const { totalItems } = useNumberItemsCart()

  return (
    <div className="flex w-10 h-10">
      <Link
        className="flex items-center w-full justify-center"
        href="/panier"
        aria-label={totalItems > 0 ? `Mon panier (${totalItems})` : 'Mon panier'}
      >
        <ShoppingBagIcon width={28} height={28} className="icon-gradient" aria-hidden="true" />
      </Link>
      {totalItems > 0 && (
        <span className="-ml-2 -mt-1 h-fit inline-flex items-center font-bold rounded-full bg-[#f2e8df] px-1.5 py-0.5 text-xs text-black">
          {totalItems}
        </span>
      )}
    </div>
  )
}
